import { Input } from 'baseui/input';
import { useEffect } from 'react';
import { usePlacesWidget } from 'react-google-autocomplete';
import { environment } from '../../environments/environment';
import { useCamera } from '../../hooks/useCamera';
import { GeoPlace } from '../../types/geoModels';

type Props = Readonly<{
  selectedPlace?: GeoPlace;
  onChange: (place: GeoPlace) => void;
  placeholder?: string;
  onFocus?: () => void;
}>;

export function MapSearchPicker({ selectedPlace, onChange, placeholder = 'Buscar lugar', onFocus }: Props) {
  const { zoomTo } = useCamera();
  const { ref } = usePlacesWidget<HTMLInputElement>({
    apiKey: environment.googleMapsAPIKey,
    inputAutocompleteValue: '',
    options: {
      types: [],
      fields: ['formatted_address', 'geometry'],
    },
    onPlaceSelected: (place) => {
      const point = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
      const address = place.formatted_address;
      zoomTo(point);
      onChange({ point, address });
    },
  });

  useEffect(() => {
    if (!selectedPlace) return;

    let current = ref.current;
    if (current) {
      current.value = selectedPlace.address;
    }
  }, [selectedPlace, ref]);

  const handleOnBlur = () => {
    let current = ref.current;
    if (current && selectedPlace) {
      current.value = selectedPlace.address;
    }
  };

  return (
    <Input
      autoComplete="off"
      name="map-search-picker"
      size="compact"
      onBlur={handleOnBlur}
      onFocus={onFocus}
      placeholder={placeholder}
      overrides={{
        Input: {
          props: {
            ref,
          },
        },
      }}
    />
  );
}
